export default __webpack_public_path__ + "static/media/tiktag-01.39dccbe3.svg";